import * as React from 'react';
import { useSelector } from 'react-redux';

import { CallButtonContainer } from './CallButton';
import { NewbuildingDecorationBanner } from '../../components/NewbuildingDecorationBanner';
import { getDecorationsBanner } from '../../selectors/newObject/getDecorationsBanner';

export const NewbuildingDecorationBannerContainer = () => {
  const banner = useSelector(getDecorationsBanner);

  if (!banner) {
    return null;
  }

  return (
    <NewbuildingDecorationBanner
      title={banner.title}
      description={banner.description}
      callButton={<CallButtonContainer />}
    />
  );
};
